<div class="brevo-export-container">
  <h2>{{__('header')}}</h2>

  <div class="info-panel">
    <div class="count-section">
      <h3>{{__('count')}}</h3>
      <div class="count-display" *ngIf="!isLoading">{{ userCount }}</div>
    </div>

    <div class="action-section">
      <button
        class="export-button"
        [disabled]="isTriggering || isExportRunning"
        (click)="triggerExport()">
        <span *ngIf="!isTriggering && !isExportRunning">{{__('trigger-button')}}</span>
        <span *ngIf="isTriggering">{{__('trigger-button')}}...</span>
        <span *ngIf="isExportRunning && !isTriggering">{{__('status-running')}}</span>
      </button>

      <div class="info-text" *ngIf="userCount === 0 && !isExportRunning">
        {{__('no-users')}}
      </div>
    </div>
  </div>

  <div class="error-message" *ngIf="exportError">
    {{ exportError }}
  </div>

  <div class="error-message" *ngIf="downloadError">
    {{ downloadError }}
  </div>

  <div class="info-text" *ngIf="downloadInfo">
    {{ downloadInfo }}
  </div>

  <div class="info-panel jobs-panel" *ngIf="jobs.length > 0">
    <div class="jobs-panel-header">
      <h3>{{__('recent-exports')}}</h3>
      <button
        class="delete-jobs-button"
        [disabled]="isDeletingJobs"
        (click)="deleteOldExports()">
        <span *ngIf="!isDeletingJobs">{{__('delete-jobs-button')}}</span>
        <span *ngIf="isDeletingJobs">{{__('delete-jobs-button-running')}}</span>
      </button>
    </div>
    <div class="info-text" *ngIf="deleteJobsResult">{{ deleteJobsResult }}</div>
    <div class="error-message" *ngIf="deleteJobsError">{{ deleteJobsError }}</div>
    <table class="jobs-table">
      <thead>
        <tr>
          <th>Status</th>
          <th>{{__('count')}}</th>
          <th>{{__('started-at')}}</th>
          <th>{{__('completed-at')}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of jobs">
          <td>
            <span class="status-badge" [class]="'status-' + job.status.toLowerCase()">
              {{__('status-' + job.status.toLowerCase())}}
            </span>
          </td>
          <td>{{ job.userCount ?? '-' }}</td>
          <td>{{ formatDate(job.startedAt) }}</td>
          <td>{{ formatDate(job.completedAt) }}</td>
          <td>
            <button
              class="download-button"
              *ngIf="job.status === 'COMPLETED'"
              [title]="__('download-button')"
              [attr.aria-label]="__('download-button')"
              (click)="downloadExport(job)">
              <fa-icon [icon]="faDownload"></fa-icon>
            </button>
            <span *ngIf="job.status === 'FAILED'" class="error-text">
              {{ job.errorMessage }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="info-panel reset-container">
    <h3 class="reset-container-title">{{__('reset-header')}}</h3>

    <div class="reset-row">
      <div class="reset-label">{{__('reset-label-date')}}</div>
      <div class="reset-action">
        <div class="reset-controls">
          <input type="date" [(ngModel)]="resetDate" class="date-input" />
          <button
            class="reset-button"
            [disabled]="isResetting || !resetDate"
            (click)="resetSince()">
            <span *ngIf="!isResetting">{{__('reset-button-short')}}</span>
            <span *ngIf="isResetting">{{__('reset-button-running')}}</span>
          </button>
        </div>
        <div class="info-text" *ngIf="resetResult">{{ resetResult }}</div>
        <div class="error-message inline-error" *ngIf="resetError">{{ resetError }}</div>
      </div>
    </div>

    <div class="reset-row">
      <div class="reset-label">{{__('reset-label-last-x')}}</div>
      <div class="reset-action">
        <div class="reset-controls">
          <input type="number" [(ngModel)]="resetLastCount" min="1" class="batch-size-input" />
          <button
            class="reset-button"
            [disabled]="isResettingLast || !resetLastCount || resetLastCount <= 0"
            (click)="resetLast()">
            <span *ngIf="!isResettingLast">{{__('reset-button-short')}}</span>
            <span *ngIf="isResettingLast">{{__('reset-last-button-running')}}</span>
          </button>
        </div>
        <div class="info-text" *ngIf="resetLastResult">{{ resetLastResult }}</div>
        <div class="error-message inline-error" *ngIf="resetLastError">{{ resetLastError }}</div>
      </div>
    </div>
  </div>
</div>
